import { generatePath, useLocation, useParams } from 'react-router-dom';
import useLocalizedNavigate from '~/hooks/useLocalizedNavigate';

const useReplaceUrlParam = (pattern: string) => {
  const params = useParams<Record<string, string>>();
  const navigate = useLocalizedNavigate();
  const location = useLocation();

  return (paramToReplace: string, newValue: string) => {
    const newPath = generatePath(pattern, {
      ...params,
      [paramToReplace]: newValue,
    });

    navigate(
      {
        pathname: newPath,
        search: location.search,
      },
      { replace: true },
    );
  };
};

export default useReplaceUrlParam;
